import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { format, parse } from "date-fns";
import OrangeFilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";

const CourierFilterModal = ({
  show,
  handleClose,
  setCustomerData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  defaultFilterData,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: filterData,
    mode: "onChange",
  });

  // Watch all form values to check if a filter has a value
  const watchedValues = watch();

  // Function to check if a tab has an active filter value
  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Company ID":
        return filterData?.companyId && filterData.companyId.trim() !== "";
      case "LMBP Code":
        return (
          filterData?.retailerCode && filterData.retailerCode.trim() !== ""
        );
      case "Pincode":
        return filterData?.pincode && filterData.pincode.trim() !== "";
      case "Created Date":
        return (
          (filterData?.fromDate && filterData.fromDate !== "") ||
          (filterData?.toDate && filterData.toDate !== "")
        );
      case "Status":
        return filterData?.status && filterData.status.length > 0;
      default:
        return false;
    }
  };

  const [selectedTab, setSelectedTab] = useState("Company ID");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = () => {
    fetchCustomerData(currentPage);
  };

  const fetchCustomerData = async (currentPage) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
        status:
          filterData.status.length > 0
            ? filterData.status.map((s) => s.toUpperCase())
            : [],
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_COURIER_MASTER_DATA}?pageSize=${pageSize}&pageNo=${1}`,
        requestBody,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setCustomerData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;
      const addressComponents = [
        user.address1,
        user.address2,
        user.address3,
        user.pincode,
        user.city,
        user.state,
        user.country,
      ].filter((component) => component != null && component !== "");
      const address =
        addressComponents.length > 0 ? addressComponents.join(", ") : "";

      return {
        ...user,
        address,
        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",
      };
    });
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const statusOptions = [
    "Approved",
    "In-Progress",
    "Blocked",
    "Pending",
    "Rejected",
  ];

  const onReset = () => {
    handleReset();
    reset(defaultFilterData);
  };

  const handleSelectAll = () => {
    setFilterData((prev) => ({
      ...prev,
      status: statusOptions,
    }));
  };

  const handleClearAll = () => {
    setFilterData((prev) => ({
      ...prev,
      status: [],
    }));
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "850px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  justifyContent: "space-between",
                }}
              >
                <div className="flex items-center gap-3">
                  <img
                    src={OrangeFilterIcon}
                    alt="filter"
                    className="h-[21px]"
                  />
                  <h5 className="modal-title main-title font-semibold">
                    Filters
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "Company ID",
                        "LMBP Code",
                        "Pincode",
                        "Created Date",
                        "Status",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="flex-grow h-fit bg-[#ffe8d4] rounded-[9px] p-3">
                      {selectedTab === "Company ID" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <input
                              type="text"
                              placeholder="Enter Company ID"
                              className="dateInput !max-w-none"
                              value={filterData?.companyId}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  "",
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  companyId: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "LMBP Code" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <input
                              type="text"
                              placeholder="Enter LMBP Code"
                              className="dateInput !max-w-none"
                              value={filterData?.retailerCode}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  "",
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  retailerCode: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Pincode" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <input
                              type="text"
                              placeholder="Enter Pincode"
                              className="dateInput !max-w-none"
                              value={filterData?.pincode}
                              maxLength={6}
                              pattern="[0-9]{6}"
                              onChange={(e) => {
                                const val = e.target.value;
                                const cleanedVal = val.replace(/[^0-9]/g, "");
                                setFilterData((prev) => ({
                                  ...prev,
                                  pincode: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value) =>
                                  !value ||
                                  !filterData.toDate ||
                                  new Date(value) <=
                                    new Date(filterData.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, filterData) =>
                                  !filterData.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value) =>
                                  !value ||
                                  !filterData.fromDate ||
                                  new Date(value) >=
                                    new Date(filterData.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, filterData) =>
                                  !filterData.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Status" ? (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <div className="flex justify-between items-center px-[0.75rem] py-2 border-b border-black border-dashed mb-2">
                              <label className="flex items-center gap-2 cursor-pointer text-[0.9rem] font-semibold text-[#000000]">
                                <input
                                  type="checkbox"
                                  checked={
                                    filterData.status.length ===
                                    statusOptions.length
                                  }
                                  onChange={() =>
                                    filterData.status.length ===
                                    statusOptions.length
                                      ? handleClearAll()
                                      : handleSelectAll()
                                  }
                                  style={{ cursor: "pointer" }}
                                />
                                Select all
                              </label>
                              <button
                                type="button"
                                className="text-[#00008B] bg-transparent border-none text-[0.9rem] font-medium cursor-pointer"
                                onClick={handleClearAll}
                              >
                                Clear all
                              </button>
                            </div>
                            {statusOptions.map((status) => (
                              <label
                                key={status}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  value={status}
                                  checked={filterData.status.includes(status)}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: prev.status.includes(value)
                                        ? prev.status.filter((s) => s !== value)
                                        : [...prev.status, value],
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status}
                              </label>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="flex btn btn-back w-[133px] h-[33px] !rounded-[8px] items-center justify-center"
                      onClick={onReset}
                    >
                      Clear
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="flex btn btn-submit w-[133px] h-[33px] !rounded-[8px] items-center justify-center"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CourierFilterModal;
